import { AutocompleteArrayInput, ReferenceArrayInput, required, TextInput } from "react-admin";
import { Grid } from "@mui/material";
import { checkPermission } from "server/security/utils";
import { getPermissions } from "auth/security/securityUtils";
import permissions from "app/permissions";
import { accountRequests } from "api/accountApi";

const SaveForm = () => {
  return (
    <>
      <Grid
        container
        spacing={2}
      >
        <Grid
          item
          md={3}
          xs={12}
        >
          <TextInput
            label="Име"
            source="name"
            validate={required()}
          />
        </Grid>
        <Grid
          item
          md={6}
          xs={12}
        >
          <TextInput
            label="Описание"
            source="description"
            validate={required()}
          />
        </Grid>
      </Grid>
      <Grid
        container
        spacing={1}
      >
        <ReferenceArrayInput
          source="permissionIds"
          reference={accountRequests.getPermissionsSelect()}
        >
          <AutocompleteArrayInput
            optionText="name"
            disabled={!checkPermission(getPermissions(), permissions.canAttachPermissionsToRoles)}
            label="Права"
            filterToQuery={q => (q?.length > 2 ? { name: q } : {})}
            fullWidth
            disableCloseOnSelect
          />
        </ReferenceArrayInput>
      </Grid>
    </>
  );
};
export default SaveForm;
